import React, { useState } from 'react';
import './RandomNumberGenerator.css'
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

// 409 = сгенерированный код уже занят (namespace кодов глобальный, MT-2) —
// коллизия невидима владельцу: молча пробуем новый код, но ограниченно.
const MAX_ATTEMPTS = 3;

const RandomNumberGenerator = () => {
  const [randomNumber, setRandomNumber] = useState(null);
  const [showCode, setShowCode] = useState(false);

  const generateRandomNumber = (attempt = 0) => {
    const newRandomNumber = Math.floor(10000000 + Math.random() * 90000000); // Генерация случайного восьмизначного числа
    setShowCode(true);
    axiosInstance.post(`user/add_registration_code?registration_code=${newRandomNumber}`)
      .then(() => {
        setRandomNumber(newRandomNumber);
      })
      .catch(error => {
        if (error.response && error.response.status === 409 && attempt + 1 < MAX_ATTEMPTS) {
          generateRandomNumber(attempt + 1);
          return;
        }
        logger.error('Error:', error);
        setRandomNumber("Ошибка");
      });
  };

  return (
    <div className='GenerateStyle'>
      <p>Нажмите “Сгенерировать” и сообщите код сотруднику</p>
      <div className='GenerateContent'>
        <button className='Generate' onClick={() => generateRandomNumber()}>Сгенерировать</button>
        {showCode ? (
          <p className='Generated'>{randomNumber}</p>
        ) : (
          <p className='Generated'>Код доступа</p>
        )}
      </div>
    </div>
  );
};

export default RandomNumberGenerator;
